import axios from 'axios';

import { languageInterceptor } from './interceptors';

const client = axios.create();

client.interceptors.request.use(languageInterceptor);

export { client as axios };
